import FormPageTemplate from '../forms/FormPageTemplate'

const PergolaLandingForm = () => {
    const landingData = {
        title: "Your Private Miami Oasis.",
        subtitle: "Redefine your backyard. We design and build custom pergolas — wood and aluminum — engineered for South Florida weather, fully permitted, and tailored to your lifestyle."
    }
    
    return (
        <FormPageTemplate
            title="GET YOUR ALUMINUM PERGOLA QUOTE NOW!"
            subtitle={landingData.title}
            defaultFormType="construction_new_project"
            returnPath="/landing-pergola"
            initialPreselect={{ type: '1', desc: 'Pergola' }}
            thankYouPath="/landing-pergola-form/thank-you"
        />
    )
}

export default PergolaLandingForm
